import type { ReceiptKind } from '../components/receipt/Receipt'
import type { Order } from '../types'

/**
 * Bu cihazın son bastığı fişler (24 Eki 2026, "Son fişler" düğmesi).
 *
 * Rulo bitince yazıcı fişi hiç basmıyor ya da yarım basıyor, tarayıcıya da
 * bunu söylemiyor. Kasiyer kağıdı takınca son fişleri buradan tekrar basıyor.
 * Liste cihazın: fişi basan bu bilgisayar, kayıt da onda.
 */
export interface PrintedSlip {
  /** Basıldığı an (ms); listede kimlik de bu. */
  at: number
  kind: ReceiptKind
  order: Order
}

const KEY = 'adissoo.printHistory'
const MAX = 30
export const PRINT_HISTORY_EVENT = 'adissoo:print-history'

export function getPrintHistory(): PrintedSlip[] {
  try {
    const raw = localStorage.getItem(KEY)
    const list: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? (list as PrintedSlip[]) : []
  } catch {
    return []
  }
}

export function recordPrint(order: Order, kind: ReceiptKind, at = Date.now()): void {
  const next = [{ at, kind, order }, ...getPrintHistory()].slice(0, MAX)
  try {
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    // Yer yoksa en eski yarısıyla dene; olmazsa liste bu sefer güncellenmez.
    try {
      localStorage.setItem(KEY, JSON.stringify(next.slice(0, MAX / 2)))
    } catch {
      return
    }
  }
  window.dispatchEvent(new Event(PRINT_HISTORY_EVENT))
}

/** Listede bir satır: tezgah fişleri tezgah tezgah, kasa fişi tek. */
export interface SlipRow {
  key: string
  at: number
  kind: ReceiptKind
  /** Tezgah adı ya da "Kasa fişi". */
  part: string
  order: Order
}

export function slipRows(history: PrintedSlip[], defaultStation: string): SlipRow[] {
  const rows: SlipRow[] = []
  for (const h of history) {
    if (h.kind === 'cash') {
      rows.push({ key: `${h.at}:kasa`, at: h.at, kind: h.kind, part: 'Kasa fişi', order: h.order })
      continue
    }
    const stations = [...new Set(h.order.lines.map((l) => l.station || defaultStation))]
    for (const st of stations) {
      const lines = h.order.lines.filter((l) => (l.station || defaultStation) === st)
      rows.push({
        key: `${h.at}:${st}`,
        at: h.at,
        kind: h.kind,
        part: st,
        order: { ...h.order, lines, itemCount: lines.reduce((n, l) => n + l.qty, 0) },
      })
    }
  }
  return rows
}
